var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0544 21.1879V15.3711H15.8611H16.2907L16.3554 14.9464L16.791 12.0853L16.8786 11.51H16.2967H14.0544V10.1488C14.0544 9.83122 14.1336 9.57821 14.2787 9.41084C14.4122 9.25678 14.663 9.1044 15.1681 9.1044H16.4155H16.9155V8.6044V6.169V5.74845L16.5012 5.67639L16.4155 6.169L16.5011 5.67638L16.501 5.67636L16.5006 5.6763L16.4997 5.67614L16.4966 5.67561L16.4856 5.67373L16.4449 5.66699C16.4097 5.66127 16.359 5.65322 16.295 5.64361C16.1671 5.6244 15.9858 5.59891 15.7699 5.57344C15.3405 5.52277 14.7647 5.471 14.1979 5.471C12.964 5.471 11.8896 5.84461 11.1231 6.61116C10.356 7.37825 9.9557 8.4803 9.9557 9.8221V11.5001H7.9411H7.4411V12.0001V14.8612V15.3612H7.9411H9.9557V21.178C5.74891 20.2438 2.6001 16.487 2.6001 12.0001C2.6001 6.87992 6.70102 2.71142 11.7952 2.60229L11.8029 2.61H12.01C17.1987 2.61 21.4001 6.81144 21.4001 12.0001C21.4001 16.4882 18.2592 20.2531 14.0544 21.1879Z",
    fill: "#171719",
    stroke: "#171719"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.40354b39eb0b589d29c631ad60edfeef.svg";
export { ForwardRef as ReactComponent };